/* eslint-disable */
import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";

/* Importing react select */
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

//import translation function for language translation
import { useTranslation } from "react-i18next";

/* import status from json */
import statusData from "../../../data/Prod/Status.json";

//import context
import { GlobalProvider } from "context/GlobalContext";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

const UserManagementFilter = () => {
  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation

  const {
    setSearchUserRoles,
    setSearchUserTags,
    setSearchUserStatus,
    setSearchUserZipcodes,
    setSearchUserCityList,
    setSearchUserStateList,
    setSearchUserCountryList,
    setSearchUserIsCompany,
    setShowUserList,
  } = useContext(GlobalProvider);

  const [rolesList, setRolesList] = useState([]); //for roles
  const [labelList, setlabelList] = useState([]); // for label list

  /* useState hook to change select values */
  const [selectedOptions, setSelectedOptions] = useState({
    roleValue: null,
    roleData: [],
    tagValue: null,
    tagData: [],
    statusValue: null,
    statusData: [],
    zipCodeValue: null,
    zipCodeData: [],
    cityValue: null,
    cityNames: [],
    stateValue: null,
    stateNames: [],
    countryValue: null,
    countryNames: [],
    isCompany: false,
  });

  //function for get all role
  const getAllRoles = async () => {
    let requestUrl =
      url.API_BASEURL + url.API_GET_ALL_ROLES + `?token=${token}`;

    const response = await getData(requestUrl);

    if (response.status) {
      const filteredData = response.data.filter(
        (item) => item.label !== "admin"
      );
      setRolesList(filteredData);
    }
  };

  /* function to get all labels */
  const getAllLabels = async () => {
    let requestUrl =
      url.API_BASEURL +
      url.API_GET_ALL_TAG +
      `?token=${token}&isselect=${true}`;

    const response = await getData(requestUrl);

    if (response.status) {
      setlabelList(response.data);
    }
  };

  //function for search
  const searchHandler = () => {
    //assign data for search
    selectedOptions.roleData.length > 0 &&
      setSearchUserRoles(selectedOptions.roleData);

    selectedOptions.tagData.length > 0 &&
      setSearchUserTags(selectedOptions.tagData);

    selectedOptions.statusData.length > 0 &&
      setSearchUserStatus(selectedOptions.statusData);

    selectedOptions.zipCodeData.length > 0 &&
      setSearchUserZipcodes(selectedOptions.zipCodeData);

    selectedOptions.cityNames.length > 0 &&
      setSearchUserCityList(selectedOptions.cityNames);

    selectedOptions.stateNames.length > 0 &&
      setSearchUserStateList(selectedOptions.stateNames);

    selectedOptions.countryNames.length > 0 &&
      setSearchUserCountryList(selectedOptions.countryNames);

    setSearchUserIsCompany(selectedOptions.isCompany);
  };

  //function for reset
  const resetHandler = () => {
    setSelectedOptions({
      roleValue: null,
      roleData: [],
      tagValue: null,
      tagData: [],
      statusValue: null,
      statusData: [],
      zipCodeValue: null,
      zipCodeData: [],
      cityValue: null,
      cityNames: [],
      stateValue: null,
      stateNames: [],
      countryValue: null,
      countryNames: [],
      isCompany: false,
    });
    setSearchUserRoles([]);
    setSearchUserTags([]);
    setSearchUserStatus([]);
    setSearchUserZipcodes([]);
    setSearchUserCityList([]);
    setSearchUserStateList([]);
    setSearchUserCountryList([]);
    setSearchUserIsCompany(false);
    setShowUserList(true);
  };

  useEffect(() => {
    getAllRoles();
    getAllLabels();
  }, []);

  return (
    <div className="collapse mt-3 user_filter" id="userfilterCollapse">
      <div className="p-3 bg-gray-200">
        <h4 className="mb-3">{t("Filter")}</h4>
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="user_filter_outer">
            <div className="row">
              {/* ======== select role section start ======== */}
              <div className="col-lg-3">
                <div className="form-group mb-3">
                  <Select
                    placeholder={t("Select role")}
                    className="nosearch_select"
                    isMulti
                    options={rolesList}
                    value={selectedOptions.roleValue}
                    onChange={(val) => {
                      setSelectedOptions((prevData) => ({
                        ...prevData,
                        roleValue: val,
                        roleData: val.map((label) => label.value),
                      }));
                    }}
                  />
                </div>
              </div>
              {/* ======== select role section end ======== */}

              {/* ======== select label section start ======== */}
              <div className="col-lg-3">
                <div className="form-group mb-3">
                  <Select
                    placeholder={t("Select tag")}
                    className="nosearch_select"
                    isMulti
                    options={labelList}
                    value={selectedOptions.tagValue}
                    onChange={(val) => {
                      setSelectedOptions((prevData) => ({
                        ...prevData,
                        tagValue: val,
                        tagData: val.map((label) => label.value),
                      }));
                    }}
                  />
                </div>
              </div>
              {/* ======== select label section end ======== */}

              {/* ======== select status start============== */}
              <div className="col-lg-3">
                <div className="form-group mb-3">
                  <Select
                    placeholder={t("Select status")}
                    className="nosearch_select"
                    isMulti
                    options={statusData}
                    value={selectedOptions.statusValue}
                    onChange={(val) => {
                      setSelectedOptions((prevData) => ({
                        ...prevData,
                        statusValue: val,
                        statusData: val.map((label) => label.value),
                      }));
                    }}
                  />
                </div>
              </div>
              {/* ======== select status end============== */}

              {/* ======== select zipcode start ============== */}
              <div className="col-lg-3">
                <div className="form-group mb-3">
                  {/* it is creatable select.No need to assign options here. */}
                  <CreatableSelect
                    placeholder={t("Enter zipcode")}
                    className="nosearch_select"
                    isMulti
                    value={selectedOptions.zipCodeValue}
                    onChange={(val) => {
                      setSelectedOptions((prevData) => ({
                        ...prevData,
                        zipCodeValue: val,
                        zipCodeData: val.map((label) => label.value),
                      }));
                    }}
                  />
                </div>
              </div>
              {/* ======== select zipcode end ============== */}

              {/* --------- select city,state and country section start -------- */}
              <div className="row">
                {/* --------- select city section start -------- */}
                <div className="col-lg-3">
                  <div className="form-group mb-3">
                    {/* it is creatable select.No need to assign options here. */}
                    <CreatableSelect
                      placeholder={t("Enter City")}
                      className="nosearch_select"
                      isMulti
                      value={selectedOptions.cityValue}
                      onChange={(val) => {
                        setSelectedOptions((prevData) => ({
                          ...prevData,
                          cityValue: val,
                          cityNames: val.map((label) => label.value),
                        }));
                      }}
                    />
                  </div>
                </div>
                {/* --------- select city section end -------- */}

                {/* --------- select state section start -------- */}
                <div className="col-lg-3">
                  <div className="form-group mb-3">
                    {/* it is creatable select.No need to assign options here. */}
                    <CreatableSelect
                      placeholder={t("Enter State")}
                      className="nosearch_select"
                      isMulti
                      value={selectedOptions.stateValue}
                      onChange={(val) => {
                        setSelectedOptions((prevData) => ({
                          ...prevData,
                          stateValue: val,
                          stateNames: val.map((label) => label.value),
                        }));
                      }}
                    />
                  </div>
                </div>
                {/* --------- select state section end -------- */}

                {/* --------- select country section start -------- */}
                <div className="col-lg-3">
                  <div className="form-group mb-3">
                    {/* it is creatable select.No need to assign options here. */}
                    <CreatableSelect
                      placeholder={t("Enter Country")}
                      className="nosearch_select"
                      isMulti
                      value={selectedOptions.countryValue}
                      onChange={(val) => {
                        setSelectedOptions((prevData) => ({
                          ...prevData,
                          countryValue: val,
                          countryNames: val.map((label) => label.value),
                        }));
                      }}
                    />
                  </div>
                </div>
                {/* --------- select country section end -------- */}

                {/* ----- is company section start ----- */}
                <div className="col-lg-3">
                  <div className="form-group mb-4 form-check">
                    <label htmlFor="iscompany" className="mt-2">
                      {t("Is Company")}
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="iscompany"
                      checked={selectedOptions.isCompany}
                      onChange={(e) => {
                        setSelectedOptions((prevData) => ({
                          ...prevData,
                          isCompany: e.target.checked,
                        }));
                      }}
                    />
                  </div>
                </div>
                {/* ----- is company section start ----- */}
              </div>

              {/* ------ button section start -------- */}
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group mb-3">
                    <div className="action d-flex gap-3 align-items-center">
                      {/* ------- search button start ------- */}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={searchHandler}
                      >
                        {t("Select")}
                      </button>
                      {/* ------- reset button end ------- */}

                      {/* ------- reset button start ------- */}
                      <Link
                        to="#"
                        className="d-flex gap-1 align-items-center text-black"
                        onClick={resetHandler}
                      >
                        <span className="d-block material-symbols-outlined icon-md">
                          sync
                        </span>
                        <span className="d-block fw-medium">
                          {t("Refresh")}
                        </span>
                      </Link>
                      {/* ------- reset button end ------- */}
                    </div>
                  </div>
                </div>
              </div>
              {/* ------ button section end -------- */}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserManagementFilter;
